import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../services/api';
import { useCart } from '../context/CartContext';

export default function Cart() {
  const { cart, updateItem, removeItem } = useCart();
  const [coupon, setCoupon] = useState('');
  const [discount, setDiscount] = useState(0);
  const [couponCode, setCouponCode] = useState('');

  const items = cart.items || [];
  const subtotal = Number(cart.total || 0);
  const shipping = subtotal >= 999 ? 0 : 99;
  const total = subtotal - discount + shipping;

  const applyCoupon = async () => {
    if (!coupon.trim()) return;
    try {
      const res = await api.post('coupons/validate/', { code: coupon });
      const d = res.data.discount_percent ? (subtotal * res.data.discount_percent / 100) : (res.data.discount_amount || 0);
      const finalDiscount = res.data.max_discount && d > res.data.max_discount ? res.data.max_discount : d;
      setDiscount(finalDiscount);
      setCouponCode(coupon);
      toast.success(`Coupon applied! ₹${finalDiscount} off`);
    } catch {
      toast.error('Invalid coupon');
      setDiscount(0);
      setCouponCode('');
    }
  };

  if (!items.length) {
    return (
      <div className="empty-state">
        <h2>Your cart is empty</h2>
        <p>Looks like you haven't added anything yet.</p>
        <Link to="/shop" className="btn btn-primary">Continue Shopping</Link>
      </div>
    );
  }

  return (
    <div className="container cart-page" style={{ display: 'grid', gridTemplateColumns: '1fr 360px', gap: 40 }}>
      <div>
        <h2 className="section-title" style={{ textAlign: 'left', margin: '0 0 24px' }}>Shopping Cart</h2>
        {items.map(item => (
          <div key={item.id} className="cart-item">
            <img src={item.image} alt={item.product_name} />
            <div className="details">
              <h3>{item.product_name}</h3>
              <p>Size: {item.size} · Color: {item.color}</p>
              <p style={{ fontWeight: 500 }}>₹{item.price}</p>
              <div className="qty-control">
                <button onClick={() => item.quantity > 1 && updateItem(item.id, item.quantity - 1)}>−</button>
                <span>{item.quantity}</span>
                <button onClick={() => updateItem(item.id, item.quantity + 1)}>+</button>
                <button onClick={() => removeItem(item.id)} style={{ marginLeft: 16, background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: 12 }}>Remove</button>
              </div>
            </div>
            <div style={{ fontWeight: 500 }}>₹{(item.price * item.quantity).toFixed(2)}</div>
          </div>
        ))}
      </div>

      <div className="cart-summary">
        <h3 style={{ fontFamily: 'var(--font-heading)', marginBottom: 20 }}>Order Summary</h3>
        <div className="row"><span>Subtotal</span><span>₹{subtotal.toFixed(2)}</span></div>
        <div className="row"><span>Shipping</span><span>{shipping === 0 ? 'Free' : `₹${shipping}`}</span></div>
        {discount > 0 && <div className="row" style={{ color: 'green' }}><span>Discount</span><span>-₹{discount.toFixed(2)}</span></div>}

        <div className="coupon-input">
          <input value={coupon} onChange={e => setCoupon(e.target.value)} placeholder="Coupon code" />
          <button onClick={applyCoupon} className="btn btn-sm btn-primary">Apply</button>
        </div>

        <div className="row total"><span>Total</span><span>₹{total.toFixed(2)}</span></div>

        <Link to={`/checkout${couponCode ? `?coupon=${couponCode}` : ''}`} className="btn btn-primary" style={{ display: 'block', textAlign: 'center', marginTop: 20, width: '100%' }}>
          Checkout
        </Link>
      </div>
    </div>
  );
}
